// extracted by mini-css-extract-plugin
export default {"container":"oRPg0Z9KotAzdkDyYtKs","row":"ZNojz5EHULR4qqZTh9LL","header":"KAM7rriiFCLHzS4haWWI","placeHolderShimmer":"ZPju1IA9Bs5RvnS0bIPN"};